import React, { useEffect, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';

import { GetRoutingProfiles } from '../../../services/Api/routingProfiles/useApiRoutingProfiles';
import { GetSecurityProfiles } from '../../../services/Api/securityProfiles/useApiSecurityProfiles';
import {
    Button,
    LoadingSpinner,
    Modal,
    RowContainer,
    SelectList,
    toast,
    Typography,
} from '../../common';

const AddUserToInstanceModal = ({ onSubmit, closeForm, defaultValues = {}, currentInstance }) => {
    const [isOptionsLoading, setIsOptionsLoading] = useState(true);
    const [securityProfiles, setSecurityProfiles] = useState([]);
    const [routingProfiles, setRoutingProfiles] = useState([]);

    const {
        register,
        handleSubmit,
        formState: { errors },
        control,
    } = useForm({ defaultValues: { ...defaultValues } });

    useEffect(() => {
        setIsOptionsLoading(false);

        GetSecurityProfiles({ instanceId: currentInstance.instanceid })
            .then((response) => {
                setSecurityProfiles(
                    response.data.SecurityProfileSummaryList.map((r) => ({
                        value: r.Id,
                        label: r.Name,
                        disabled: r.Name.toLowerCase() === 'admin',
                    }))
                );
                setIsOptionsLoading(false);
            })
            .catch((error) => {
                console.error(error);
                toast.error();
            });

        GetRoutingProfiles({ instanceId: currentInstance.instanceid })
            .then((response) => {
                setRoutingProfiles(
                    response.data.RoutingProfileSummaryList.map((r) => ({
                        value: r.Id,
                        label: r.Name,
                    }))
                );
                setIsOptionsLoading(false);
            })
            .catch((error) => {
                console.error(error);
                toast.error();
            });
    }, [currentInstance.instanceid]);

    const onFormSubmit = (data) =>
        onSubmit(currentInstance, data.routingProfile.value, data.securityProfile.value);

    return (
        <Modal closeModal={closeForm} title="Add User to Instance">
            <form onSubmit={handleSubmit(onFormSubmit)}>
                <div className="pb-4">
                    <Typography variant="body3" color="grey-normal" className="pb-1">
                        Routing Profile*
                    </Typography>
                    {isOptionsLoading ? (
                        <LoadingSpinner />
                    ) : (
                        <Controller
                            name="routingProfile"
                            isClearable
                            control={control}
                            render={({ field: { value, onChange } }) => (
                                <SelectList
                                    options={routingProfiles}
                                    value={value}
                                    onChange={onChange}
                                    error={errors.routingProfile}
                                />
                            )}
                            {...register('routingProfile', { required: true })}
                        />
                    )}
                    {errors.routingProfile && (
                        <Typography variant="body3" color="error" className="pt-1">
                            Routing Profile*
                        </Typography>
                    )}
                </div>
                <div className="pb-4">
                    <Typography variant="body3" color="grey-normal" className="pb-1">
                        Security Profile*
                    </Typography>
                    <Controller
                        name="securityProfile"
                        control={control}
                        render={({ field: { value, onChange } }) => (
                            <SelectList
                                options={securityProfiles}
                                value={value}
                                onChange={onChange}
                                error={errors.securityProfile}
                            />
                        )}
                        {...register('securityProfile', { required: true })}
                    />
                    {errors.securityProfile && (
                        <Typography variant="body3" color="error" className="pt-1">
                            Routing Profile*
                        </Typography>
                    )}
                </div>
                <RowContainer spacing="medium" className="justify-center">
                    <Button type="button" onClick={() => closeForm && closeForm()}>
                        Cancel
                    </Button>
                    <Button type="primary">Create</Button>
                </RowContainer>
            </form>
        </Modal>
    );
};

export default AddUserToInstanceModal;
